import { useEffect, useReducer } from 'react';

import type { Editor } from '@tiptap/react';

export const useEditorUpdate = (editor: Editor | null) => {
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    if (!editor) {
      return;
    }

    const update = () => forceUpdate();
    editor.on('transaction', update);
    editor.on('selectionUpdate', update);

    return () => {
      editor.off('transaction', update);
      editor.off('selectionUpdate', update);
    };
  }, [editor]);
};
